import { useEffect } from 'react';
import { useLocation } from 'react-router';
export const useSavedLocation = () => {
  const {
    pathname: location
  } = useLocation();
  const redirect = sessionStorage.getItem('redirect');
  useEffect(() => {
    if (location && redirect !== location) {
      sessionStorage.setItem('redirect', location);
    }
    // Only update location when it changes, not when another tab updates the redirect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
};